module.exports = __webpack_public_path__ + "images/portfolio2-3fe9b806b8c63cebc043cc61e21ee534.jpg";


//////////////////
// WEBPACK FOOTER
// ./app/frontend/images/portfolio2.jpg
// module id = 15
// module chunks = 0